import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdAuction from './components/AdAuction';
import ClientPortal from './components/ClientPortal';
import AdminPortal from './components/AdminPortal';
import MyAds from './components/MyAds';
import Login from './components/Login';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Login mode="register" />} />
                <Route path="/auction" element={<AdAuction />} />
                <Route path="/client" element={<ClientPortal />} />
                <Route path="/admin" element={<AdminPortal />} />
                <Route path="/myads" element={<MyAds />} />
            </Routes>
        </Router>
    );
};

export default App;
